import { useMutation } from "@apollo/client";
import { SetAutoTunerBy1801CpuIdResponse, SetAutoTunerBy1801CpuIdArgs, SET_AUTO_TUNER_BY_1801_CPU_ID } from "../../../Services/Agrisys_GqlDataCaller/ServiceToolCalls/GQLCalls/setAutoTunerBy1801CpuId";
import { ConfirmModal } from "../../GlobalModals";

export function AutoTune1801Modal({ closeModal, domain, cpuId, port }: { closeModal: () => void, domain: string, cpuId: string, port: number }) {
	const [autoTune, { data: dataAutoTune, loading: loadingAutoTune, error: errorAutoTune, reset: resetState }] = useMutation<SetAutoTunerBy1801CpuIdResponse, SetAutoTunerBy1801CpuIdArgs>(
		SET_AUTO_TUNER_BY_1801_CPU_ID,
		{ fetchPolicy: "network-only" }
	);

	async function commit() {
		await autoTune({
			variables: {
				domain: domain,
				cpuId,
				port: port,
				value: 2,
			},
		});
	}

	function handleCloseModal() {
		resetState();
		closeModal();
	}

	function getMessage() {
		const errorMessage = "Error: did not autotune";

		if (!dataAutoTune) {
			return undefined;
		}
		if (loadingAutoTune) {
			return undefined;
		}
		if (errorAutoTune) {
			return errorMessage
		}
		if (!dataAutoTune.device.setAutoTunerBy1801CpuId.success) {
			return errorMessage;
		}
		if (dataAutoTune.device.setAutoTunerBy1801CpuId.success) {
			return "Autotune success"
		}
	}

	return (
		<ConfirmModal
			disclaimer="This action will autotune the antenna, are you sure you want to perform this action?"
			onCancel={handleCloseModal}
			onConfirm={commit}
			message={
				getMessage()
			}
			loading={loadingAutoTune}
		/>
	);
}